export const requiredMessage = 'Campo obrigatório';
